export default __webpack_public_path__ + "/images/fortnite-llama.png";